<template>
    <v-main class="pa-2" fluid>

        <v-toolbar flat>
            <v-spacer></v-spacer>
            <RangePicker @reloadData="loadData" :range="selectedRange" />
        </v-toolbar>

        <v-row>

        <v-col>
            <v-data-table hide-default-footer
            item-key="id" :show-select="checkGate('users-mgmt')" :loading="loadingForm"
            v-model="editedItem.wages" :headers="headers" :items="wages_report" :items-per-page="-1" class="elevation-1">
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                <v-simple-checkbox :disabled="item.disabled"
                :value="isSelected"
                @input="select($event)"
                ></v-simple-checkbox>
             </template>
             
                <template v-slot:item.startDate="{ item }">
                    <span>
                        {{ new Date(item.startDate).toLocaleString("en-AU", {
                            timeZone: "UTC", weekday: 'short', month: 'short',
                            day: 'numeric'
                        }) }}</span> -
                    <span>
                        {{ new Date(item.endDate).toLocaleString("en-AU", {
                            timeZone: "UTC", weekday: 'short', year: 'numeric',
                            month: 'short', day: 'numeric'
                        }) }}</span>
                </template>
                <template v-slot:item.amount_paid="props">
                    <v-edit-dialog :return-value.sync="props.item.amount_paid" @save="addIndex(props.item)"
                        @open="edit(props.item)">
                        {{ props.item.amount_paid }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.amount_paid" label="Edit" single-line
                                type="number"></v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>
                <template v-slot:item.detail="props">
                    <v-edit-dialog :return-value.sync="props.item.detail" @open="edit(props.item)" @save="save">
                        {{ props.item.detail }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.detail" label="Reason for pay over or under"></v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>
            </v-data-table>
        </v-col>
    </v-row> 

        <v-row>
            <v-col cols="12" md="6">
                <v-subheader>Tips for Staff Transactions</v-subheader>

                <v-data-table hide-default-footer :headers="tipsHeaders" :items="staff_tips" :items-per-page="-1">
                    <template v-slot:item.created_at="{ item }">
                        <span>
                            {{ new Date(item.created_at).toLocaleString("en-AU", {
                                timeZone: "UTC", weekday: 'short', month: 'short',
                                day: 'numeric'
                            }) }}</span>
                    </template>
                    <template v-slot:item.amount="{ item }">
                        <span>${{ item.amount }} </span>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-subheader>Total Tips</v-subheader>
                <v-data-table hide-default-footer :headers="totalsHeaders" :items="totals" :items-per-page="-1">
                    <template slot="body.append">
                        <tr class="pink--text">
                            <th class="title">Total</th>
                            <th class="title">${{ total_tips }}</th>
                        </tr>
                    </template>
                </v-data-table>
                
                <v-form @submit.prevent="split_tips" v-model="valid" v-if="checkGate('users-mgmt')">
                    <fieldset class="inline-form right">
                        <v-btn type="Submit" :disabled="editedItem.wages.length == 0 || total_shared_tips > 0 || total_tips == 0" color="blue darken-1">Split</v-btn>
                    </fieldset>
                </v-form>
            </v-col>
        </v-row>
        <v-row v-if="detail_wagesbyrange.length > 0">
            <v-col>
                
                <v-subheader>Detail</v-subheader>
                <v-select v-if="checkGate('users-mgmt')" max-width="30%" v-model="userDetailId" :items="users" item-text="name" item-value="id"
          label="Select a Name">
        </v-select>
                <v-data-table :headers="detailHeaders" :items="wagesByUser" :items-per-page="7" class="elevation-1">
                    <template v-slot:item.workDate="{ item }">
                            {{ new Date(item.workDate).toLocaleString("en-AU", {
                                timeZone: "UTC", weekday: 'short', month: 'short',
                                day: 'numeric'
                            }) }}
                    </template>
                    <template v-slot:item.tasks="{ item }">
                        <template v-for="task in item.tasks">
                            <span>{{ task.name }}</span>&nbsp;
                        </template>
                        <p>{{ item.other }}</p>
                    </template>
                </v-data-table>
            </v-col>
    </v-row>
    </v-main>
</template>

<script>
import { mapState } from 'vuex'
import RangePicker from '../components/RangePicker.vue'

export default {
    props: ['range'],
    components: { RangePicker },
    data() {
        return {
            headers: [
                { text: 'Dates', align: 'start', sortable: true, value: 'startDate', },
                { text: 'Name', align: 'start', sortable: true, value: 'user.name', },
                { text: 'Jumps', align: 'start', sortable: true, value: 'jumps', },
                { text: 'Packs', align: 'start', sortable: true, value: 'packs' },
                { text: 'Loads', align: 'start', sortable: true, value: 'flights' },
                { text: 'Hrs', align: 'start', sortable: true, value: 'hrs' },
                { text: 'WC', align: 'start', sortable: true, value: 'wc1' },
                { text: 'lb/wc', align: 'start', sortable: true, value: 'wc2' },
                { text: 'Tips', align: 'start', sortable: true, value: 'tips' },
                { text: 'Shared Tips', align: 'start', sortable: true, value: 'staff_tips' },
                { text: 'Owed', align: 'start', sortable: true, value: 'amount_owed' },
                { text: 'Paid', align: 'start', sortable: true, value: 'amount_paid' },
                { text: 'Over or Under', align: 'start', sortable: true, value: 'over_under' },
                { text: 'Detail', align: 'start', sortable: true, value: 'detail' },
                { text: '', align: 'start', sortable: true, value: 'actions' },
            ],

            detailHeaders: [
                { text: 'Date', align: 'start', sortable: true, value: 'workDate', },
                { text: 'Name', align: 'start', sortable: true, value: 'user.name', },
                { text: 'Start Time', align: 'start', sortable: true, value: 'start_time', },
                { text: 'Finish Time', align: 'start', sortable: true, value: 'end_time', },
                { text: 'Break', align: 'start', sortable: true, value: 'break' },
                { text: 'Not working/DownTime', align: 'start', sortable: true, value: 'notworking' },
                { text: 'Hrs', align: 'start', sortable: true, value: 'hrs' },
                { text: 'Completed Tasks', align: 'start', sortable: true, value: 'tasks' },
                { text: '', align: 'start', sortable: true, value: 'actions' },
            ],
            datePicker: false,
            dialog: false,
            editedIndex: -1,
            editedIndexes: [],
            valid: false,
            lazy: true,
            isEditing: null,
            editedItem: {
                startDate: '',
                endDate: '',
                wages: []
            },
            loadingForm: false,
            nameRules: [
                v => !!v || 'Required',
            ],

            userDetailId: null

        }
    },

    mounted() {


        let r = this.range.split('_')

        this.$store.dispatch('fetchWagesReportsbyRange', {
            range: r
        })

        this.$store.dispatch('fetchStaffTips', {
            range: r
        })

        this.$store.dispatch('fetchWagesDetail',{
            range: r
        })

    },



    computed: {
        ...mapState(['wages_reports', 'staff_tips','detail_wagesbyrange']),

        wagesByUser () {
            

return this.userDetailId ? this.detail_wagesbyrange.filter(detail => detail.user_id == this.userDetailId) : this.detail_wagesbyrange


        },

        users () {

            const uniqueUsers = {}

                this.detail_wagesbyrange.forEach( w => {
                    const user_id = w.user.id

                    if(!uniqueUsers[user_id]){
                        uniqueUsers[user_id] = w.user
                    }
                })
        
        return Object.values(uniqueUsers)
        },

        wages_report (){

            this.wages_reports.forEach(w => {
                w.disabled = w.tips > 0 ? true : false
               //return  w
            })

            return this.wages_reports
        },
        totals() {

            return [{
                from: 'Staff',
                amount: (this.sum(this.staff_tips, 'amount') * .97).toFixed(2)
            },
            {
                from: 'TI',
                amount: ((this.sum(this.wages_reports, 'tips') * .97) * .20).toFixed(2)
            }]

        },

        total_tips () {
            return this.sum(this.totals, 'amount')
        },

        total_shared_tips() {
            return this.sum(this.wages_reports,'staff_tips')
        },

        selectedRange() {
            return this.range.split('_')
        },

        tipsHeaders() {
            return this.getHeaders(this.staff_tips)
        },
        totalsHeaders() {
            return this.getHeaders(this.totals)
        },
    },


    watch: {

        dialog(val) {
            val || this.close()
        },

        range(val) {


            if (val.length == 2) { //if the two dates have been selected

                this.loadFormData(val)
                //this.reloadData(val)
                this.datePicker = false
                this.loadingForm = false

            }
        }
    },

    methods: {

        split_tips() {
            
            this.loadingForm = true
            let fraction = this.total_tips / this.editedItem.wages.length,
            self = this
           
           this.editedItem.wages.forEach( x => {
            let i = self.wages_reports.indexOf(x)
            x.staff_tips = fraction.toFixed(2)
            x.amount_owed = (x.amount_owed + fraction).toFixed(2)
            self.wages_reports[i] = Object.assign({}, x)
            
           })

           this.wages_reports.forEach(w => {
            
                if( w.tips > 0) {
                w.staff_tips = (w.tips * 0.97) - ((w.tips * 0.97) * 0.2)
                w.amount_owed = parseFloat(w.amount_owed) + parseFloat(w.staff_tips)
                w.amount_owed = w.amount_owed.toFixed(2)
                w.staff_tips = w.staff_tips.toFixed(2)
            }
                return w
            })
            
            


                      let edited_wages = this.wages_reports.filter(w => {
                return w.staff_tips > 0
            })

            axios.put('/api/wages_reports/batchUpdate', {wages : edited_wages})
                    .then(response => {
                        this.loadingForm = false
                        this.editedItem.wages = []

                    })
                    .catch(err => {
                        console.log(err)
                    })
        },

        addIndex(item) {

            item.over_under = (parseInt(item.amount_paid) - item.amount_owed).toFixed(2)

            if (this.editedIndex > -1) {

             //   this.save()

            }

        },



        // loadFormData(range) {

        //     this.editedItem.startDate = range[0]
        //     this.editedItem.endDate = range[1]

        //     this.$store.dispatch('fetchWagesbyRange') {
        //         range: range
        //     })

        //     this.dialog = true
        // },


        loadData(range) {

            this.$store.dispatch('fetchWagesReportsbyRange', {
                range: range

            })

            this.$store.dispatch('fetchStaffTips', {
                range: range
            })

            this.$store.dispatch('fetchWagesDetail',{
            range: range
        })

        },

        edit(item) {
            this.editedIndex = this.wages_reports.indexOf(item)
            //this.editedItem = Object.assign({}, item)
            this.editedItem = this.wages_reports[this.editedIndex]
            //this.dialog = true
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1

            })
        },

        save_tips(){

            let edited_wages = this.wages_reports.filter(w => {
                return w.staff_tips > 0
            })

            axios.put('/api/wages_reports/batchUpdate', {wages : edited_wages})
                    .then(response => {
                       // console.log(response)
                        // Object.assign(this.wages_reports[this.editedIndex], this.editedItem)
                        this.close()

                    })
                    .catch(err => {
                        console.log(err)
                    })

        },

        save() {

            if (this.editedIndex > -1) {

                axios.put('/api/wages_reports/' + this.editedItem.id, this.editedItem)
                    .then(response => {
                        // Object.assign(this.wages_reports[this.editedIndex], this.editedItem)
                        this.close()

                    })
                    .catch(err => {
                        console.log(err)
                    })


            } else {

                this.editedItem.wages = this.wagesbyrange

                axios.post('/api/wages_reports', this.editedItem)
                    .then(response => {

                        //this.$store.dispatch('fetchWagesReportsbyRange')
                        //  this.wages_reports.push(this.editedItem)
                        this.wages_reports = response.data

                        this.close()

                    })
                    .catch(err => {
                        console.log(err)
                    })

            }

        },

        updateStatus(item) {

            this.editedIndex = this.wages_reports.indexOf(item)
            this.editedItem = Object.assign({}, item)

            axios.put('/api/wages_reports/updateStatus/' + this.editedItem.id, this.editedItem)
                .then(response => {

                    this.close()

                })
                .catch(err => {
                    console.log(err)
                })
        },


        deleteReport(id) {

            confirm('Are you sure you want to delete this Report? This action can not be undone') &&

                axios.delete('/api/wages_reports/' + id)
                    .then(response => {

                        const index = this.wages_reports.map(function (f) { return f.id }).indexOf(id)

                        this.$store.state.wages_reports.splice(index, 1)
                    })
                    .catch(err => {
                        console.log(err)
                    })
        }
    }
}
</script>